var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Php(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12c-13.45703,0 -24,5.71094 -24,13c0,7.28906 10.54297,13 24,13c13.45703,0 24,-5.71094 24,-13c0,-7.28906 -10.54297,-13 -24,-13zM22.50781,16h2.62109l-0.83203,4h2.33984c1.48438,0 2.48047,0.20703 3.04688,0.72656c0.55469,0.51172 0.72266,1.35156 0.5,2.49609l-1.03906,4.77734h-2.66406l0.95703,-4.41797c0.11719,-0.60547 0.07031,-1.02734 -0.13281,-1.25c-0.20312,-0.22266 -0.64844,-0.33203 -1.31641,-0.33203h-2.09766l-1.26562,6h-2.625zM11,20h5.33203c2.54297,0 4.08203,1.70313 3.48047,4.24609c-0.69922,2.95313 -2.57422,3.75391 -6.01953,3.75391h-1.64844l-0.52344,3h-2.64844zM32,20h5.33203c2.54297,0 4.08203,1.70313 3.48047,4.24609c-0.69922,2.95313 -2.57422,3.75391 -6.01953,3.75391h-1.64844l-0.52344,3h-2.64844zM13.26953,22l-0.75391,4h1.71094c1.48047,0 2.85547,-0.16797 3.08594,-2.375c0.08594,-0.85547 -0.26953,-1.625 -1.98047,-1.625zM34.26953,22l-0.75391,4h1.71094c1.48047,0 2.85547,-0.16797 3.08594,-2.375c0.08594,-0.85547 -0.26953,-1.625 -1.98047,-1.625z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Php);
export default __webpack_public_path__ + "static/media/icons8-php.80c932a086956c1836f78f3953068804.svg";
export { ForwardRef as ReactComponent };